import { render } from "./TenantTable.vue?vue&type=template&id=8b28c560"
import script from "./TenantTable.vue?vue&type=script&lang=js"
export * from "./TenantTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__